import { ComponentSettings, empty, FieldTypes } from "../settings/settings";

const settings = {
  text: {
    createMatch: {
      de: "Zuordnen",
      en: "Match",
      nl: "Match",
    },
    deleteMatch: {
      de: "Zuordnung aufheben",
      en: "Unmatch",
      nl: "Unmatch",
    },
    datasheet: {
      de: "Datenblatt",
      en: "Datasheet",
      nl: "Datasheet",
    },
    select: {
      de: "Abgleichen",
      en: "Match",
      nl: "Koppelen",
    },
    selected: {
      de: "Ausgewählt",
      en: "Selected",
      nl: "Toegewezen",
    },
    suitable: {
      de: "Nicht geeignet",
      en: "Not Suitable",
      nl: "Niet geschikt",
    },
    markAsNotSuitableConfirm: {
      de: "Sind Sie sicher, dass Sie als nicht geeignet markieren möchten?",
      en: "Are you sure you want to mark as not suitable?",
      nl: "Weet je zeker dat je als niet geschikt wilt markeren?",
    },
    unmarkOptionAsNotSuitableConfirm: {
      de: "Sind Sie sicher, dass Sie die Markierung für diese Option entfernen möchten?",
      en: "Are you sure you want to unmark option ?",
      nl: "Weet je zeker dat je de markering voor deze optie wilt verwijderen ?",
    },
    markAllMatchesAsNotSuitableConfirm: {
      de: "Sind Sie sicher, dass Sie alle Treffer als nicht geeignet markieren möchten ?",
      en: "Are you sure you want to mark all matches as not suitable ?",
      nl: "Weet je zeker dat je alle overeenkomsten als niet geschikt wilt markeren ?",
    },
    unmarkAllMatchesAsNotSuitableConfirm: {
      de: "Sind Sie sicher, dass Sie alle Markierungen als nicht geeignet entfernen möchten ?",
      en: "Are you sure you want to unmark all ?",
      nl: "Weet je zeker dat je alle markeringen als niet geschikt wilt verwijderen ?",
    },
    rohs: {
      de: "RoHS",
      en: "RoHS",
      nl: "RoHs",
    },
    originalData: {
      de: "Kundendaten (Import)",
      en: "Client Data (Import)",
      nl: "Client Data (Import)",
    },
    currentMatch: {
      de: "Aktuelle Zuweisung",
      en: "Current Match",
      nl: "Current Match",
    },
    noResults: {
      de: "Keine Ergebnisse gefunden",
      en: "No results found",
      nl: "Geen resultaten",
    },
    unmatch: {
      en: "Unmatch",
      de: "Zuweisung aufheben",
      nl: "Unmatch",
    },
    edited: {
      en: "Edited",
      de: "Bearbeitet",
      nl: "Bewerkt",
    },
    matchingItem: {
      en: "Matching items",
      de: "Einheiten verbinden",
      nl: "Matching items",
    },
    matching: {
      en: "Matching",
      de: "Einheiten",
      nl: "Matching",
    },
    backToMatchingQueue: {
      en: "Back to Matching Queue",
      de: "Zurueck zur Matching-Warteschlange",
      nl: "Terug naar matchingwachtrij",
    },
    reviewMatchCustomerPartNumber: {
      en: "Review Match - Customer Part Number(CPN)",
      de: "Zuordnung pruefen - Kundenteilenummer(CPN)",
      nl: "Match beoordelen - klantonderdeelnummer(CPN)",
    },
    reviewMatchSubtitle: {
      en: "Imported item vs component database",
      de: "Importierter Artikel vs. Komponentendatenbank",
      nl: "Geimporteerd item versus componentdatabase",
    },
    sortBy: {
      en: "Sort by:",
      de: "Sortieren nach:",
      nl: "Sorteren op:",
    },
    sortSelectPlaceholder: {
      en: "Select",
      de: "Auswaehlen",
      nl: "Selecteren",
    },
    findBetterMatch: {
      en: "Search",
      de: "Suchen",
      nl: "Search",
    },
    matchReason: {
      en: "Note",
      de: "Hinweis",
      nl: "Opmerking",
    },
  },
  field: {
    matchReason: {
      type: FieldTypes.value,
      text: {
        en: "Note",
        de: "Hinweis",
        nl: "Opmerking",
      },
    },
  },
  url: {},
  permission: {},
  list: {
    columns: empty,
    columnRows: empty,
  },
  additionalInfo: {},
};

export const matchingManufacturer: ComponentSettings<typeof settings> =
  settings;
